import { useState } from 'react';
import { gio } from '../chung/api';
import { useHoiLai } from '../chung/hoi-lai';
import type { TrangNhatKy } from '../chung/kieu';
import { Khung } from './manh';

/**
 * Nhật ký hành động — CHỈ OWNER thấy mục này (15/09). Backend trả 403 cho admin
 * thường, nút ở cột trái cũng không hiện với họ (`ManAdmin`, `chiOwner`).
 *
 * Màn TRA CỨU: hỏi lại 30 giây là đủ. Lọc theo ngày làm việc và theo mã hành động
 * (lọc hành động làm trên máy — một trang 100 dòng, không cần hỏi server thêm).
 */
const TEN_HANH_DONG: Record<string, string> = {
  DANG_NHAP: 'Đăng nhập',
  TAO_TAI_KHOAN: 'Tạo tài khoản',
  KHOA_TAI_KHOAN: 'Khoá tài khoản',
  MO_TAI_KHOAN: 'Mở tài khoản',
  DAT_LAI_MAT_KHAU: 'Đặt lại mật khẩu',
  XAC_NHAN_DON: 'Xác nhận đơn',
  HUY_GIO: 'Huỷ giỏ',
  TRA_LAI_DON: 'Trả lại đơn',
  HOAN_TRA_DON: 'Hoàn trả (khách trả hàng)',
  NAP_EXCEL: 'Nạp Excel',
  SUA_SAN_PHAM: 'Sửa sản phẩm',
  DOI_ANH: 'Đổi ảnh',
  NHAP_KHO: 'Nhập kho',
  KIEM_KE: 'Kiểm kê',
  XUAT_EXCEL: 'Xuất báo cáo Excel',
};
/** Hành động đụng tới TIỀN hoặc TÀI KHOẢN thì tô đỏ — mắt lướt qua bắt được ngay. */
const NANG: ReadonlySet<string> = new Set([
  'HOAN_TRA_DON',
  'TRA_LAI_DON',
  'HUY_GIO',
  'KHOA_TAI_KHOAN',
  'DAT_LAI_MAT_KHAU',
  'XUAT_EXCEL',
  'KIEM_KE',
]);

const chip: React.CSSProperties = {
  padding: '8px 15px',
  fontSize: 13,
  fontWeight: 600,
  borderRadius: 'var(--tron)',
  whiteSpace: 'nowrap',
};

export function MucNhatKy() {
  const [ngay, datNgay] = useState('');
  const [hd, datHd] = useState('');
  const [trang, datTrang] = useState(1);

  const ts = new URLSearchParams();
  if (ngay) ts.set('ngay', ngay);
  if (trang > 1) ts.set('trang', String(trang));
  const kq = useHoiLai<TrangNhatKy>(`/api/nhat-ky?${ts}`, 30_000);

  const tatCa = kq.duLieu?.danh_sach ?? [];
  const ds = hd ? tatCa.filter((d) => d.hanh_dong === hd) : tatCa;
  const soTrang = kq.duLieu ? Math.max(1, Math.ceil(kq.duLieu.tong / kq.duLieu.moi_trang)) : 1;
  const cacHd = [...new Set(tatCa.map((d) => d.hanh_dong))];

  return (
    <Khung
      tieuDe="Nhật ký"
      phu={
        kq.duLieu
          ? `${kq.duLieu.tong} dòng · chỉ chủ cửa hàng thấy mục này · không xoá được`
          : 'đang tải…'
      }
    >
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
        <button onClick={() => datHd('')} className={hd === '' ? 'lom-nho' : undefined} style={{ ...chip, color: hd === '' ? 'var(--nhan)' : undefined }}>
          Tất cả
        </button>
        {cacHd.map((m) => (
          <button key={m} onClick={() => datHd(m)} className={hd === m ? 'lom-nho' : undefined} style={{ ...chip, color: hd === m ? 'var(--nhan)' : undefined }}>
            {TEN_HANH_DONG[m] ?? m}
          </button>
        ))}
        <label style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span className="nhan-chu">Ngày làm việc</span>
          <input
            type="date"
            value={ngay}
            onChange={(e) => {
              datNgay(e.target.value);
              datTrang(1);
            }}
            style={{ width: 180, padding: '10px 14px' }}
          />
        </label>
      </div>

      {kq.duLieu && ds.length === 0 && (
        <div className="hien-len" style={{ padding: '48px 20px', textAlign: 'center', color: 'var(--chu-3)' }}>
          Không có dòng nào.
        </div>
      )}

      {ds.map((d, i) => (
        <div
          key={d.id}
          className="noi-nho truot-phai"
          style={{
            animationDelay: `${Math.min(i, 8) * 25}ms`,
            padding: '11px 16px',
            marginBottom: 8,
            display: 'flex',
            alignItems: 'baseline',
            gap: 14,
          }}
        >
          <span className="so" style={{ fontSize: 12, color: 'var(--chu-3)', flexShrink: 0, minWidth: 118 }}>
            {gio(d.luc)}
          </span>
          <span
            className={`the ${NANG.has(d.hanh_dong) ? 'the-nhan' : 'the-mo'}`}
            style={{ flexShrink: 0, minWidth: 150, textAlign: 'center' }}
          >
            {TEN_HANH_DONG[d.hanh_dong] ?? d.hanh_dong}
          </span>
          <span style={{ fontWeight: 600, flexShrink: 0 }}>{d.nguoi.ho_ten}</span>
          <span style={{ fontSize: 12, color: 'var(--chu-3)', flexShrink: 0 }}>{d.nguoi.username}</span>
          <span style={{ flex: 1, minWidth: 0, fontSize: 'var(--chu-nho)', color: 'var(--chu-2)', overflowWrap: 'anywhere' }}>
            {d.chi_tiet}
          </span>
        </div>
      ))}

      {soTrang > 1 && (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center', marginTop: 8 }}>
          <button onClick={() => datTrang((c) => Math.max(1, c - 1))} disabled={trang <= 1} style={{ padding: '11px 18px' }}>
            ← Mới hơn
          </button>
          <span className="so" style={{ fontSize: 13, color: 'var(--chu-2)' }}>
            {trang} / {soTrang}
          </span>
          <button onClick={() => datTrang((c) => Math.min(soTrang, c + 1))} disabled={trang >= soTrang} style={{ padding: '11px 18px' }}>
            Cũ hơn →
          </button>
        </div>
      )}
    </Khung>
  );
}
